import { useEffect, useState } from "react";
import settings from "../utils/settings";
const useStatProducts = (customerType, periodType, fromDate, toDate) => {
  const [products, setProducts] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  useEffect(() => {
    const getTotalRevenue = async () => {
      const { token, branchId } = settings();
      let urlBranch = "";
      if (branchId) urlBranch = `&branch_id=${branchId}`;
      try {
        const result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/stat/products?sort={"life_time.${customerType}.total_qty": -1}&period_type=${periodType}&from=${fromDate}&to=${toDate}${urlBranch}&addon={"product_id":1}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        const jsonResult = await result.json();

        setProducts(jsonResult.payload.products);

        return setLoading(false);
      } catch (error) {
        setError(error);
        return setLoading(false);
      }
    };
    getTotalRevenue();
  }, [customerType, periodType, fromDate, toDate]);
  return { products, loading, error };
};

export default useStatProducts;
